import { Vector3 } from "three";
import { SideType } from "../../../../store/types/store";
import { useShelvingStore, useStoreRoom } from "../../../../store";
import { useStoreSystem } from "../../../../store/useStoreSystem";

export const getWallLineVertices = (newSide: SideType) => {
    const lineVertices: Vector3[] = [];
    const proMode = useStoreSystem.getState().proMode;
    const roomHeight = useStoreRoom.getState().height;
    const roomWidth = useStoreRoom.getState().length;
    const roomDepth = proMode ? useStoreRoom.getState().depth : useStoreRoom.getState().cameraDistance;
    const currentShelving =
        newSide !== "top" ? useShelvingStore.getState().shelving[newSide] : useShelvingStore.getState().shelving.front;
    const offsetCeiling = currentShelving.offsetCeiling;
    const totalHeight = currentShelving.height;
    const totalLength = currentShelving.length;
    const roomHeightVector = (roomHeight - offsetCeiling - totalHeight / 2) / 1000;
    const sections = currentShelving.sections;
    const sectionsWidth =
        sections.length === 0
            ? 0
            : currentShelving.sideIndent + sections[sections.length - 1].offset + sections[sections.length - 1].width;
    const sideIndent = currentShelving.sideIndent;

    switch (newSide) {
        case "front":
            if (currentShelving.sections.length > 0) {
                lineVertices.push(new Vector3((-roomWidth / 2 + sectionsWidth) / 1000, roomHeightVector, 0));
            } else {
                lineVertices.push(new Vector3((-roomWidth / 2 + sideIndent + totalLength) / 1000, roomHeightVector, 0));
            }
            lineVertices.push(new Vector3((-roomWidth + sideIndent) / 2000, roomHeightVector, 0));
            break;
        case "back":
            if (currentShelving.sections.length > 0) {
                lineVertices.push(
                    new Vector3((roomWidth / 2 - sectionsWidth) / 1000, roomHeightVector, roomDepth / 1000)
                );
            } else {
                lineVertices.push(
                    new Vector3((roomWidth / 2 - sideIndent - totalLength) / 1000, roomHeightVector, roomDepth / 1000)
                );
            }
            lineVertices.push(new Vector3((roomWidth - sideIndent) / 2000, roomHeightVector, roomDepth / 1000));
            break;
        case "left":
            if (currentShelving.sections.length > 0) {
                lineVertices.push(new Vector3(-roomWidth / 2000, roomHeightVector, (roomDepth - sectionsWidth) / 1000));
            } else {
                lineVertices.push(
                    new Vector3(-roomWidth / 2000, roomHeightVector, (roomDepth - sideIndent - totalLength) / 1000)
                );
            }
            lineVertices.push(new Vector3(-roomWidth / 2000, roomHeightVector, (roomDepth - sideIndent) / 1000));
            break;
        case "right":
            if (currentShelving.sections.length > 0) {
                lineVertices.push(new Vector3(roomWidth / 2000, roomHeightVector, sectionsWidth / 1000));
            } else {
                lineVertices.push(new Vector3(roomWidth / 2000, roomHeightVector, roomDepth / 1000));
            }
            lineVertices.push(new Vector3(roomWidth / 2000, roomHeightVector, 0));
            break;
        case "top":
            lineVertices.push(new Vector3(-roomWidth / 2000, roomHeightVector, 0));
            lineVertices.push(new Vector3(roomWidth / 2000, roomHeightVector, roomDepth / 1000));
            break;
        default:
    }
    return lineVertices;
};
